import * as React from "react";
import PropTypes from "prop-types";
import {
  StyledTableCell,
  StyledTableRow,
} from "../../table/BaseTable/BaseTable";
import LoaderWrapper from "../../wrapper/LoaderWrapper";

function areRowDataPropsEqual(oldProps, newProps) {
  return (
    oldProps.isLoading === newProps.isLoading
  );
}

const FilterTableLoadingRow = React.memo((props) => {


  return (
    <>
    {props.isLoading &&
    <StyledTableRow>
      <StyledTableCell
        colSpan={props.colSpan}
      >
        <LoaderWrapper showLoader={props.isLoading} />
      </StyledTableCell>
    </StyledTableRow>
    }
    </>
  );
}, areRowDataPropsEqual);

export default FilterTableLoadingRow;

FilterTableLoadingRow.propTypes = {
  isLoading: PropTypes.bool,
  colSpan: PropTypes.number
};

FilterTableLoadingRow.defaultProps = {
  isLoading: false,
  colSpan: 1
};
